module.exports = __webpack_public_path__ + "img/Bog-Blob.ebb573af.svg";